import instance from "../services/baseService";

export const getDashboardDetails = async () => {
    try {
        const response = await instance.get(`/api/v1/dashboard`);
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard details:', error);
        throw error;
    }
};